<template>
  <div class="wrapper">
    <base-bread-crumb :currBreadCrumb="currBreadCrumb"></base-bread-crumb>
    <div class="ccui-notice-app-container-detail">
      <div class="ccui-notice-app-container-detail-body clearfix">
        <div class="ccui-notice-app-container-detail-left">
          <div class="notice-title">{{ schemeObj.schemeName }}</div>
          <div class="notice-project-info">
            <div class="notice-project-info-li">
              <span>{{ $t("page.content.projectCode") }}：</span
              >{{ schemeObj.schemeCode }}
            </div>
            <div class="notice-project-info-li">
              <span>{{ $t("page.content.publishTime") }}：</span
              >{{ schemeObj.noticeStartTime }}
            </div>
            <div
              class="notice-project-info-li"
              v-if="$route.query.type != 7 && $route.query.type != 8"
            >
              <span>{{ $t("page.content.publishUnit") }}：</span
              >{{ schemeObj.opUnitName }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="template-notice-detail-body ccui-clearfix">
      <div class="template-notice-detail-full">
        <div class="notice-detail-title">{{ noticeTypeName }}</div>
        <div class="notice-detail-ul clearfix">
          <div class="notice-detail-li ccui-clearfix">
            <span class="notice-detail-li-title"
              >{{ $t("page.content.noticeTitle") }}：</span
            >
            <div class="notice-detail-li-con">{{ pageData.noticeTitle }}</div>
          </div>
          <div class="notice-detail-li ccui-clearfix">
            <span class="notice-detail-li-title"
              >{{ $t("page.content.noticeContent") }}：</span
            >
            <div
              class="notice-detail-li-con rich-text"
              v-html="pageData.textInfo"
            ></div>
          </div>
        </div>
        <div class="notice-detail-title" style="padding-top: 40px;">
          {{ $t("page.content.fileList") }}
        </div>
        <detailTable
          class="dic-sub-table-style01"
          :tableData="pageData.fileinfoBOS"
          :tableHead="fileHead"
          :showIndex="true"
        ></detailTable>

        <div class="notice-detail-title" style="padding-top: 40px;">
          {{ $t("page.content.relatedNoticeList") }}
        </div>
        <detailTable
          :tableData="relateNoticeList"
          :tableHead="noticeHead"
          :showIndex="true"
        >
          <template slot="noticeTitle" slot-scope="{ row }">
            <el-button size="mini" type="text" @click="handleNoticeTitle(row)">
              {{ row.noticeTitle }}
            </el-button>
          </template>
        </detailTable>
      </div>
    </div>
  </div>
</template>

<script>
import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb.vue";
import detailTable from "@/app/shop/components/detail-table";
import { commonTableWidth } from "@/setting/setting";
import { mixinHomePage } from "@/mixins/mixin-common/mixin-homePage";
import { announcementStatus } from "@/setting/setting";
import { qryNoticeDetail, qryRelatedNoticeList } from "@/app/shop/api/shopping";
export default {
  name: "viewNoticeSimpleDetail",
  components: {
    baseBreadCrumb,
    detailTable
  },
  mixins: [mixinHomePage],
  data() {
    return {
      currBreadCrumb: [],
      fileHead: [
        { label: this.$t("page.content.fileName"), prop: "fileName" },
        { label: this.$t("page.content.fileDesc"), prop: "fileSumm" },
        {
          label: this.$t("page.content.operation"),
          slot: "opp",
          align: "center",
          width: 200
        }
      ],
      noticeHead: [
        {
          label: this.$t("page.content.type"),
          prop: "noticeTypeName",
          width: 150
        },
        {
          label: this.$t("page.content.title"),
          prop: "noticeTitle",
          slot: "noticeTitle"
        },
        // {
        //   label: this.$t("page.content.link"),
        //   prop: "purStepName",
        //   width: 150
        // },
        {
          label: this.$t("page.content.publishTime"),
          prop: "createTime",
          width: commonTableWidth.dateTimeWidth
        }
      ],
      subPackageFlag: "", //是否分包
      // packageList: [],
      matDetailList: [],
      pageData: {},
      relateNoticeList: [], //相关公告列表
      schemeObj: {
        opUnitName: this.$route.query.opUnitName, //发布单位
        schemeName: this.$route.query.schemeName, //项目名称
        schemeCode: this.$route.query.schemeCode //项目编号
      },
      noticeTypeName: "",
      type: this.$route.query.type
    };
  },
  activated() {
    this.init();
  },
  deactivated() {
    this.currBreadCrumb = [];
  },
  methods: {
    init() {
      switch (this.type) {
        case "3":
          this.noticeTypeName = this.$t("page.content.labelMenu1");
          break;
        case "4":
          this.noticeTypeName = this.$t("page.content.labelMenu5");
          break;
        case "7":
          this.noticeTypeName = this.$t("page.content.labelMenu3");
          break;
        case "8":
          this.noticeTypeName = this.$t("page.content.labelMenu2");
          break;
      }
      //查询公告信息及附件列表
      qryNoticeDetail({
        schemeId: this.$route.query.schemeId,
        noticeId: this.$route.query.noticeId,
        // purStep: 1,
        qryFileFlag: true
      }).then(res => {
        if (res.data.code === "0" && res.data.data) {
          this.pageData = res.data.data;
          this.$set(
            this.noticeHead[2],
            "isHidden",
            this.pageData.purStep !== "1"
          );
          this.currBreadCrumb.push({
            title: this.pageData.noticeTitle
          });
          this.schemeObj.noticeStartTime = this.pageData.noticeStartTime;
        }
      });

      //查询相关公告列表
      qryRelatedNoticeList({
        schemeId: this.$route.query.schemeId,
        noticeId: this.$route.query.noticeId
      }).then(res => {
        if (res.data.code === "0") {
          this.relateNoticeList = res.data.data.map(item=>{
            item.noticeTypeName=announcementStatus[item.noticeTypeName]||''
            return item
          });
      
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.template-detail-body .detail-box .detail-info {
  width: calc(100% - 240px);
}
/deep/ .template-detail-body .detail-box {
  margin-top: 20px;
  margin-bottom: 0;
}
</style>
